module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "menu-wrapper"
  }, [_c('el-menu', {
    ref: "menu",
    staticClass: "menus",
    attrs: {
      "mode": "horizontal",
      "default-active": _vm.currentIndex,
      "router": true
    }
  }, [_vm._l((_vm.Menus), function(menu) {
    return [(menu.children && (_vm.Customer.isPrimaryAccount ? true : _vm.PermissionJson.find(function (n) { return n === menu.index; }))) ? _c('el-submenu', {
      key: menu.index,
      staticClass: "menu",
      attrs: {
        "data-index": menu.index,
        "index": menu.index
      },
      nativeOn: {
        "mouseenter": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.handleMouseEnter($event)
        },
        "mouseleave": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.handleMouseOut($event)
        }
      }
    }, [_c('template', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(menu.title))]), _vm._v(" "), _vm._l((menu.children), function(submenu) {
      return _c('el-menu-item', {
        key: submenu.index,
        attrs: {
          "index": submenu.index
        }
      }, [_c('span', [_vm._v(_vm._s(submenu.title))])])
    })], 2) : _vm._e(), _vm._v(" "), (!menu.children && (_vm.Customer.isPrimaryAccount ? true : _vm.PermissionJson.find(function (n) { return n === menu.index; }))) ? _c('el-menu-item', {
      key: menu.index,
      staticClass: "menu",
      attrs: {
        "data-index": menu.index,
        "index": menu.index
      },
      nativeOn: {
        "mouseenter": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.handleMouseEnter($event)
        },
        "mouseleave": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.handleMouseOut($event)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(menu.title))])]) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "menu-hover-bar",
    style: (_vm.barStyle)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "user-panel"
  }, [_c('div', {
    staticClass: "logined"
  }, [_vm._v("\n      您好！\n      "), _c('span', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.Customer.userName))]), _vm._v(" "), _c('el-button', {
    staticClass: "logout-btn",
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.handleLogout
    }
  }, [_vm._v("退出")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('a', {
    attrs: {
      "href": "http://www.spr-atm.com/"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/logo.png"),
      "alt": "logo"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60a1bad9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Header.vue
// module id = 742
// module chunks = 0